import store from 'store2';

const storageAPI = (type: 'local' | 'session') => ({
  get: <Value>(key: string) => store[type].get(key) as Value,
  set: <Value>(key: string, value: Value) => store[type].set(key, value),
  remove: (key: string) => store[type].remove(key),
  clearAll: () => store[type].clearAll()
});

const storage = {
  local: storageAPI('local'),
  session: storageAPI('session')
};

export default storage;
